import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {sendOriginWelcomeEmail} from 'src/openapi/admin/apis/UsersEmailsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
};

export const useSendOriginWelcomeEmail = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(
        () => apiDispatch(sendOriginWelcomeEmail({userId})),
        [userId, apiDispatch],
    );

    return useCommonEventHook({eventAction});
};
